<template>
    <div :class="'relative w-full ' + ' ' + wrapperCssClasses">
        <label
            v-if="label"
            :for="id"
            :class="'mb-2 block font-semibold' + ' ' + labelClasses"
        >
            <span v-html="label"></span>
        </label>

        <div class="relative flex w-full items-center">

            <input
                :id="id"
                :name="name"
                :ref="id"
                :class="
                    theme + ' '+
                    (disabled
                        ? 'disabled'
                        : '') +
                        cssClasses + ' ' +
                    ($page.props.errors[name] ? ' has_errors' : '')
                "
                :type="type"
                :value="modelValue"
                @input="updateInput"
                :disabled="disabled"
                :required="required"
                :placeholder="this.placeholder ?? this.label"
            />

            <form-error-warning-triangle :name="name"/>


        </div>


        <field-error
            v-if="!hideErrors"
            :field-name="label"
            :message="$page.props.errors[name]"
        />
        <div class="mt-1 mb-3 text-[14px] text-gray-600 " v-if="hint">
            {{ hint }}
        </div>

    </div>
</template>

<script>
import FieldError from './FieldError.vue'
import FormErrorWarningTriangle from './FormErrorWarningTriangle.vue'

export default {
    name: 'FormInput',
    components: { FormErrorWarningTriangle, FieldError },
    props: {
        modelValue: {
            type: [String, Number],
            default: '',
        },
        type: {
            type: String,
            default: 'text',
        },
        id: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        name: {
            type: String,
            default: null,
        },
        placeholder: {
            type: [String, Number],
            default: null,
        },
        hint: {
            type: String,
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        required: {
            type: Boolean,
            default: false,
        },
        theme: {
            type: String,
            default: 'light',
        },
        wrapperCssClasses: {
            type: String,
            default: '',
        },
        labelClasses: {
            type: String,
            default: 'block text-[14px]',
        },
        cssClasses: {
            type: String,
            default: '',
        },
        hideErrors: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        updateInput (event) {
            this.$emit('update:modelValue', event.target.value)
        },
    },
}
</script>
